export function currencyFilter(
  value: any,
  decimals: number = 2,
  separator: "," | "." = ",",
  fractionSeparator: "," | "." = "."
) {
  value = String(+value);

  const symbol = "$";
  const valueSplitted = value.split(".");
  const valueLeft: string = valueSplitted[0];
  const valueRight: string = valueSplitted[1];

  const left: string[] = [];
  let right: string = "";

  valueLeft
    .split("")
    .reverse()
    .forEach((digit: string, index: number) => {
      left.push(digit);
      if (value.split("").length !== index + 1 && (index + 1) % 3 === 0) {
        left.push(separator);
      }
    });

  right = valueRight
    ? valueRight.substr(0, decimals) +
      Array(Math.max(0, decimals - valueRight.substr(0, decimals).length))
        .fill(0)
        .join("")
    : right;

  return `${symbol} ${left.reverse().join("")}${fractionSeparator}${
    right !== "" ? `${right}` : "00"
  }`;
}
